export default {
  value: '$2a$10$Menr5JGoX0bUQ11qAGOhC.NcbqjAaj.jvLi6eASHL.ZFOqzQ8CA0m',
};
